import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'

export const NAME = 'roadClosures'

const roadClosuresIsLoading = (state = true, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return true
    case ActionTypes.FETCH_FAILURE:
    case ActionTypes.FETCH_SUCCESS:
      return false
    default:
      return state
  }
}

const byId = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS: {
      let byId = {}
      action.closures.forEach((e) => (byId[e.id] = e))
      return byId
    }
    case ActionTypes.ADD_CLOSURE:
    case ActionTypes.EDIT_CLOSURE: {
      let byId = { ...state }
      byId[action.closure.id] = action.closure
      return byId
    }
    case ActionTypes.REMOVE_CLOSURE:
      let byId = { ...state }
      byId[action.closureId] = undefined
      return byId
    case ActionTypes.HOVER_SEGMENT_START:
      if (!action.closureId) return state
      return {
        ...state,
        [action.closureId]: {
          ...state[action.closureId],
          roadSegments: state[action.closureId].roadSegments.map((segment) => {
            segment.hover = segment.hover || segment.id === action.segmentId
            return segment
          }),
        },
      }
    case ActionTypes.HOVER_SEGMENT_END:
      if (!action.closureId) return state
      return {
        ...state,
        [action.closureId]: {
          ...state[action.closureId],
          roadSegments: state[action.closureId].roadSegments.map((segment) => {
            segment.hover = segment.hover && segment.id !== action.segmentId
            return segment
          }),
        },
      }
    default:
      return state
  }
}

const allKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      return action.closures.map((e) => e.id)
    case ActionTypes.ADD_CLOSURE:
      if (state.includes(action.closure.id)) return state
      else return [...state, action.closure.id]
    case ActionTypes.REMOVE_CLOSURE:
      return state.filter((id) => id !== action.closureId)
    default:
      return state
  }
}

const agencyKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_AGENCIES_SUCCESS:
      return action.agencies.map((i) => i.id)
    default:
      return state
  }
}

const agenciesById = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_AGENCIES_SUCCESS:
      let byId = {}
      action.agencies.forEach((i) => (byId[i.id] = i))
      return byId
    default:
      return state
  }
}

const initialSelected = { closureIds: [], current: 0 }
const selected = (state = initialSelected, action) => {
  const { closureIds, current } = state
  switch (action.type) {
    case ActionTypes.SELECT_CLOSURES:
      return {
        closureIds: action.closureIds,
        current: 0,
      }
    case ActionTypes.NEXT_CLOSURE:
      return {
        ...state,
        current: current + (current < closureIds.length - 1 ? 1 : 0),
      }
    case ActionTypes.PREV_CLOSURE:
      return {
        ...state,
        current: current - (current > 0 ? 1 : 0),
      }
    case ActionTypes.CLEAR_SELECTION:
    case ActionTypes.ADD_CLOSURE:
    case ActionTypes.EDIT_CLOSURE:
      return initialSelected
    default:
      return state
  }
}

const initialEditor = {
  agencyId: -1,
  reason: -1,
  notes: '',
  pending: false,
  roadSegments: [],
  error: '',
}
const editor = (state = initialEditor, action) => {
  switch (action.type) {
    case ActionTypes.OPEN_EDITOR:
      return action.closure || initialEditor
    case ActionTypes.CLOSE_EDITOR:
    case ActionTypes.ADD_CLOSURE:
    case ActionTypes.EDIT_CLOSURE:
      return initialEditor
    case ActionTypes.SET_AGENCY_ID:
      return { ...state, agencyId: action.agencyId }
    case ActionTypes.SET_NOTES:
      return { ...state, notes: action.notes }
    case ActionTypes.SET_PENDING:
      return { ...state, pending: action.pending }
    case ActionTypes.SET_REASON:
      return { ...state, reason: action.reason }
    case ActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.error,
      }
    case ActionTypes.ADD_SEGMENTS:
      const existingIds = state.roadSegments.map((s) => s.id)
      const addedIds = action.segments.map((s) => s.id)

      const newSegments = action.segments
        .filter((s) => !existingIds.includes(s.id))
        .map((s) => {
          s.new = true
          return s
        })
      const oldSegments = state.roadSegments.map((s) => {
        if (s.removed && addedIds.includes(s.id)) {
          s.removed = false
        }
        return s
      })

      return {
        ...state,
        roadSegments: [...oldSegments, ...newSegments],
      }
    case ActionTypes.REMOVE_SEGMENTS:
      const segments = state.roadSegments
        .filter((s) => !s.new || !action.segments.includes(s.id))
        .map((s) => {
          s.removed = s.removed || action.segments.includes(s.id)
          return s
        })
      return {
        ...state,
        roadSegments: segments,
      }
    case ActionTypes.HOVER_SEGMENT_START: {
      const segments = state.roadSegments.map((segment) => {
        segment.hover = segment.hover || segment.id === action.segmentId
        return segment
      })
      return {
        ...state,
        roadSegments: segments,
      }
    }
    case ActionTypes.HOVER_SEGMENT_END:
      return {
        ...state,
        roadSegments: state.roadSegments.map((segment) => {
          segment.hover = segment.hover && segment.id !== action.segmentId
          return segment
        }),
      }
    default:
      return state
  }
}

const roadClosures = combineReducers({
  byId,
  allKeys,
  roadClosuresIsLoading,
  selected,
  editor,
  agencyKeys,
  agenciesById,
})

export default roadClosures
